import { FC, ReactElement } from 'react'
import RegisterSkeleton from '../login/skeleton'

const PasswordSkeleton: FC = ({ children }): ReactElement => {
  return (
    <RegisterSkeleton title='Recuperação de Senha.'>
      {children}
    </RegisterSkeleton>
  )
}

export default PasswordSkeleton
